import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { NDE, PHOTOS } from "@/lib/data";

const Story = () => (
  <section
    id="story"
    className="relative py-16 sm:py-24 overflow-hidden"
    style={{ background: "radial-gradient(ellipse 55% 45% at 80% 10%, rgba(124,116,242,0.1) 0%, transparent 60%), #0B1021" }}
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-14 items-center">
        {/* Portrait */}
        <Reveal className="relative order-1">
          <div className="relative rounded-[28px] overflow-hidden border border-[#D4AF37]/25 shadow-2xl shadow-black/80">
            <img
              src={PHOTOS.blazerPortrait}
              alt="Susan Grau — the near-death experience that began her life as a medium"
              className="w-full aspect-[3/4] object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1021] via-transparent to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-7">
              <p className="font-display italic text-xl text-[#FDFBF7] leading-snug">
                "{NDE.quote}"
              </p>
              <p className="eyebrow mt-3">— Susan Grau</p>
            </div>
          </div>
        </Reveal>

        {/* Story beats */}
        <div className="order-2">
          <Reveal>
            <p className="eyebrow flex items-center gap-3">
              <span className="hairline w-10 inline-block" /> {NDE.eyebrow}
            </p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-[2.9rem] mt-5 text-[#FDFBF7] leading-[1.15]">
              {NDE.titleLines[0]}
              <br />
              <em className="text-gold-gradient italic">{NDE.titleLines[1]}</em>
              <br />
              {NDE.titleLines[2]}
            </h2>
          </Reveal>

          <div className="mt-10 relative">
            <div className="absolute left-[7px] top-3 bottom-3 w-px bg-gradient-to-b from-[#7C74F2]/50 via-[#D4AF37]/50 to-transparent" />
            {NDE.beats.map((b, i) => (
              <Reveal key={b.h} delay={0.1 + i * 0.09} className="relative pl-10 pb-8 last:pb-0">
                <motion.span
                  className="absolute left-0 top-1 w-[15px] h-[15px] rounded-full border border-[#D4AF37] bg-[#0B1021] flex items-center justify-center"
                  whileInView={{ scale: [0.6, 1.2, 1] }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 + i * 0.09, duration: 0.5 }}
                >
                  <span className="w-[5px] h-[5px] rounded-full bg-[#F3D068]" />
                </motion.span>
                <h3 className="font-display text-xl sm:text-2xl text-[#FDFBF7]">{b.h}</h3>
                <p className="text-sm sm:text-base text-[#9CA3AF] font-light mt-2 leading-relaxed max-w-xl">
                  {b.p}
                </p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.35}>
            <p className="mt-9 text-[#C5CEE0] font-light leading-relaxed border-l-2 border-[#D4AF37]/40 pl-6">
              Everything guests experience on January 14th flows from that night — the reason she
              can stand on the Saban stage and say with certainty:{" "}
              <em className="text-[#F3D068]">this is not the end of your story with the people you love.</em>
            </p>
          </Reveal>

          {/* How she connects */}
          <div className="grid sm:grid-cols-2 gap-4 mt-10">
            {NDE.clairs.map((c, i) => (
              <Reveal key={c.h} delay={0.1 + i * 0.07}>
                <div className="glass rounded-2xl p-5 h-full">
                  <p className="text-[#F3D068] font-medium text-sm tracking-wide">{c.h}</p>
                  <p className="text-xs text-[#9CA3AF] font-light mt-2 leading-relaxed">{c.p}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <p className="text-xs text-[#8A99B5] font-light mt-6 leading-relaxed">{NDE.clairsNote}</p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Story;
